import { Boundary, BoundaryApiFactory, JrBoundary, BoundaryWitnessSchedule } from '@/api'
import { BaseUserActionRequest } from '@/requests/baseRequest'
import { AxiosPromise } from 'axios'

/**
 * 境界立会申請登録(申請者)
 */
export class ApplicantCreateRequest extends BaseUserActionRequest {
  private boundary: Boundary
  constructor(boundary: Boundary) {
    super()
    this.boundary = boundary
  }

  protected request(): AxiosPromise<Boundary> {
    const api = BoundaryApiFactory()
    return api.boundaryApplicantCreate(this.boundary)
  }
}

/**
 * JR側 境界立会作成
 */
export class CreateRequest extends BaseUserActionRequest {
  private boundary: JrBoundary
  constructor(boundary: JrBoundary) {
    super()
    this.boundary = boundary
  }

  protected request(): AxiosPromise<JrBoundary> {
    const api = BoundaryApiFactory()
    return api.boundaryCreate(this.boundary)
  }
}

/**
 * JR側 境界立会更新
 */
export class UpdateRequest extends BaseUserActionRequest {
  private boundary: JrBoundary
  private boundaryId: number
  constructor(boundaryId: number, boundary: JrBoundary) {
    super()
    this.boundaryId = boundaryId
    this.boundary = boundary
  }

  protected request(): AxiosPromise<JrBoundary> {
    const api = BoundaryApiFactory()
    return api.boundaryUpdate(this.boundaryId, this.boundary)
  }
}

/**
 * 境界立会 現地立会日程保存
 */
export class WitnessScheduleUpdate extends BaseUserActionRequest {
  private boundaryId: number
  private data: BoundaryWitnessSchedule
  constructor(boundaryId: number, dateTime: string) {
    super()
    this.boundaryId = boundaryId
    this.data = {
      witness_schedule_time: dateTime,
    }
  }

  protected request(): AxiosPromise<BoundaryWitnessSchedule> {
    const api = BoundaryApiFactory()
    return api.boundaryWitnessWitnessSchedule(this.boundaryId, this.data)
  }
}
